import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useForceUpdate } from 'hooks';
import { SatelliteManager, ScheduleManager } from 'models';

import { getIconFromScheduleStatus, toReadableTimeFromNow } from 'utils';

interface Props {
    satellite?: SatelliteManager.Satellite;
    schedule: ScheduleManager.Schedule;
}

const SatelliteSubSummary: React.FunctionComponent<Props> = ({
    satellite,
    schedule,
}) => {
    const forceUpdate = useForceUpdate();
    const now = new Date();

    const [updateRateFast, setUpdateRate] = useState(true);

    useEffect(() => {
        const interval = setInterval(
            () => {
                forceUpdate();

                const time = Date.now();

                const startTime = schedule.start_time.getTime();
                const stopTime = schedule.stop_time.getTime();

                const shouldBeFast =
                    startTime - time < 90_000 ||
                    (time > startTime && time < stopTime) ||
                    time - stopTime < 90_000;

                setUpdateRate(shouldBeFast);
            },
            updateRateFast ? 1_000 : 30_000,
        );

        return () => {
            clearInterval(interval);
        };
    }, [updateRateFast, schedule]);

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        gap: 1,
                        alignItems: 'center',
                    }}
                >
                    {getIconFromScheduleStatus(schedule.status)}
                    <Typography variant="h6">{satellite?.name}</Typography>
                    <Typography variant="subtitle1">
                        ({satellite?.catalogue_number})
                    </Typography>
                </Box>

                <Typography variant="subtitle1">
                    {now < schedule.start_time &&
                        `Starting ${toReadableTimeFromNow(
                            schedule.start_time,
                        )}`}
                    {now > schedule.start_time &&
                        now < schedule.stop_time &&
                        `Ending ${toReadableTimeFromNow(schedule.stop_time)}`}
                    {now > schedule.stop_time &&
                        `Ended ${toReadableTimeFromNow(schedule.stop_time)}`}
                </Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Typography variant="subtitle1">
                    <b>Satellite Owner:</b> {satellite?.organisation.name}
                </Typography>
            </Box>
        </>
    );
};

SatelliteSubSummary.displayName = 'SatelliteSubSummary';
export default SatelliteSubSummary;
